import { styled } from "styled-components";

export const Container = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const CardTitle = styled.h4`
  color: rgb(57, 92, 163);
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 2rem;
`;
